import Vue from 'vue';
import Moment from 'moment';
import store from '../store';

// Check for reference here: https://momentjs.com/docs/#/parsing/string-format/
Vue.filter('time', (value, format, utc = false) => {
  const company = store.getters.getCompany;
  if (!value) {
    return value;
  }
  if (utc) {
    return Moment.utc(value).locale(company.locale).format(format);
  }
  return new Moment(value).locale(company.locale).format(format);
});
